import { useFormContext } from "react-hook-form";

import { ui } from "@patient-watch/ui";
import type { LooseRHFField } from "./utils/loose-rhf-field";

interface Props {
    name: string;
    label: string;
    required?: boolean;
}

const YesNo: React.FC<Props> = ({ name, label, required = false }) => {
    const { control } = useFormContext();
    return (
        <ui.FormField
            control={control}
            name={name}
            render={({ field }: { field: LooseRHFField }) => (
                <ui.FormItem className="space-y-3">
                    <ui.FormLabel>
                        {label}
                        {required && <span className="ml-0.5 text-red-500">*</span>}
                    </ui.FormLabel>
                    <ui.FormControl>
                        <ui.RadioGroup
                            onValueChange={field.onChange}
                            defaultValue={field.value}
                            className="flex items-center space-x-3 space-y-0 bg-slate-100 mx-auto p-4 rounded-md w-fit"
                        >
                            <ui.FormItem className="flex items-center space-x-3 space-y-0">
                                <ui.FormControl>
                                    <ui.RadioGroupItem className="p-2" value="yes" />
                                </ui.FormControl>
                                <ui.FormLabel className="font-normal">Yes</ui.FormLabel>
                            </ui.FormItem>
                            <ui.FormItem className="flex items-center space-x-3 space-y-0">
                                <ui.FormControl>
                                    <ui.RadioGroupItem className="p-2" value="no" />
                                </ui.FormControl>
                                <ui.FormLabel className="font-normal">No</ui.FormLabel>
                            </ui.FormItem>
                        </ui.RadioGroup>
                    </ui.FormControl>
                    <ui.FormMessage />
                </ui.FormItem>
            )}
        />
    );
};

export default YesNo;
